import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-col w-full items-start space-x-1 text-base" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["data-dusk", "onClick"]
const _hoisted_4 = ["data-dusk"]
const _hoisted_5 = {
  key: 0,
  class: "flex w-full border-t border-gray-300"
}
const _hoisted_6 = ["data-dusk", "onClick"]

import {
  PropType,
  computed,

  ref
} from 'vue';
import { arrayEquals } from '@/helpers/array.helper';

interface ChildTab {
  statuses: string[];
  label: string;
  name: string;
}
interface TabConsultWithChildren {
  label: string;
  name: string;
  count?: number;
  children?: ChildTab[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultStatusSelector',
  props: {
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  emitSingleValues: {
    type: Boolean,
    default: false
  },
  tabs: {
    type: Array as PropType<TabConsultWithChildren[]>,
    default: () => []
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedStyle = {
  label: 'text-gray-900',
  total: 'text-white bg-primary-500 rounded'
};
const unselectedStyle = {
  label: 'text-gray-500',
  total: 'text-gray-500 bg-gray-200 rounded-md'
};

const activeTabIndex = computed<number>(() => {
  const index = props.tabs.findIndex((tab) =>
    tab.name === props.modelValue?.[0] ||
        tab.children?.find((child) => arrayEquals(child.statuses, props.modelValue))
  );
  return index >= 0 ? index : 0;
});
const activeChildIndex = ref<number | null>(0);

const optionStyle = computed(() => [
  props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
]);

const parentOptionStyle = computed(() => [
  optionStyle.value,
  (activeChildren.value?.length && 'pb-4')
]);

const activeChildren = computed<ChildTab[] | undefined>(
  () => props.tabs[activeTabIndex.value]?.children
);

const select = (tabIndex: number, childIndex: number | null = null) => {
  if (!props.disabled) {
    activeChildIndex.value = childIndex;
    const children = props.tabs[tabIndex]?.children;
    const status = children ? children[childIndex]?.statuses :
      (props.emitSingleValues ? [props.tabs[tabIndex].name] : []);
    emit('update:modelValue', status);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, tabIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tabIndex,
          class: _normalizeClass(["flex select-none leading-none text-base font-medium", parentOptionStyle.value]),
          "data-dusk": `consult-group-status-selector-${tab.name}`,
          onClick: ($event: any) => (select(tabIndex, tab.children ? 0 : null))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center space-x-2 px-4 py-3", [
            tabIndex === 0 && activeTabIndex.value !== tabIndex && tab.name === 'view-all' && 'border-r border-gray-300',
            activeTabIndex.value === tabIndex
              ? 'bg-gray-100 rounded-md border-r border-transparent'
              : 'bg-transparent',
            activeTabIndex.value !== 0 && tabIndex === 1 && __props.tabs[0]?.name === 'view-all' && 'ml-2',
          ]])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["leading-none text-base font-medium", 
              activeTabIndex.value === tabIndex
                ? selectedStyle.label
                : unselectedStyle.label
            ])
            }, _toDisplayString(tab.label), 3),
            (typeof tab.count === 'number')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex items-center justify-center p-1 text-2xs font-semibold", 
              activeTabIndex.value === tabIndex
                ? selectedStyle.total
                : unselectedStyle.total
            ]),
                  "data-dusk": `consult-group-status-selector-${tab.name}-count`
                }, _toDisplayString(tab.count), 11, _hoisted_4))
              : _createCommentVNode("", true)
          ], 2)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (activeChildren.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeChildren.value, (child, childIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: childIndex,
              class: _normalizeClass(["select-none leading-none text-lg font-medium pt-4", optionStyle.value]),
              "data-dusk": `consult-status-selector-${child.name}`,
              onClick: ($event: any) => (select(activeTabIndex.value, childIndex))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center space-x-2 px-3 py-2", [
            activeChildIndex.value === childIndex
              ? 'bg-gray-100 rounded-md'
              : 'bg-transparent',
          ]])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["leading-none text-sm font-medium", 
              activeChildIndex.value === childIndex
                ? selectedStyle.label
                : unselectedStyle.label
            ])
                }, _toDisplayString(child.label), 3)
              ], 2)
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})